export const SAVED_SEARCH_ERRORS_MAP = new Map<string, string>([
    ['Saved_Search_Load_Forbidden', 'ERRORS.SAVED_SEARCH_LOAD_FORBIDDEN'],
    ['Saved_Search_Creation_Forbidden', 'ERRORS.SAVED_SEARCH_UPDATE_FORBIDDEN'],
    ['Saved_Search_Creation_Failed', 'ERRORS.SAVED_SEARCH_CREATION_FAILED'],
    ['Saved_Search_Update_Forbidden', 'ERRORS.SAVED_SEARCH_UPDATE_FORBIDDEN'],
    ['Saved_Search_Update_Failed', 'ERRORS.SAVED_SEARCH_UPDATE_FAILED'],
    ['Saved_Search_Deletion_Forbidden', 'ERRORS.SAVED_SEARCH_DELETE_FORBIDDEN'],
    ['Saved_Search_Deletion_Failed', 'ERRORS.SAVED_SEARCH_DELETE_FAILED'],
]);